module.exports = __webpack_public_path__ + "img/filters-in-use.11a1f67f.png";